import { render, staticRenderFns } from "./Whoweare.vue?vue&type=template&id=788bf125&scoped=true&"
import script from "./Whoweare.vue?vue&type=script&lang=js&"
export * from "./Whoweare.vue?vue&type=script&lang=js&"
import style0 from "./Whoweare.vue?vue&type=style&index=0&id=788bf125&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788bf125",
  null
  
)

component.options.__file = "Whoweare.vue"
export default component.exports